import { useEffect } from 'react';
import { autoOpenedStatusSessionKey } from '@/constants';
import { useModal } from '@/context/modalContext';
import { useAutoOpenCardPickerStatus } from '@/hooks/memberHooks';
import { modalTypes } from '@/components/common/modals/constants';

const useAutoOpenCardPickerModal = () => {
  const { shouldShowCardPicker } = useAutoOpenCardPickerStatus();
  const { setModalName } = useModal();

  useEffect(() => {
    if (
      window.sessionStorage.getItem(autoOpenedStatusSessionKey) !== '1' &&
      shouldShowCardPicker
    ) {
      setModalName(modalTypes.SELECT_CARD_MODAL);
    }
  }, [shouldShowCardPicker, setModalName]);
};

export default useAutoOpenCardPickerModal;
